namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor('Matrix.Workflow.WorkflowInstanceChat', [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class WorkflowInstanceChat extends Serenity.TemplatedWidget<any> implements Serenity.IReadOnly {

        private items: WorkflowInstanceLogRow[];
        //private uploadedFile: Serenity.UploadedFile;
        private searchTerm: string;
        private _workflowInstanceId: number;

        constructor(div: JQuery) {
            super(div);

            this.refresh();

            new Serenity.QuickSearchInput(this.byId('SearchInput'), {
                onSearch: (field, term, done) => {
                    this.searchTerm = term;
                    this.refresh();
                    done(true);
                }
            })

            this.byId('ChatInput').keypress(e => {
                if (e.which == 13) {
                    var text = (this.byId('ChatInput').val() || "").trim();
                    if (!text.length) {
                        Q.notifyWarning('Please enter some text for the message!');
                        return;
                    }

                    //var attachment = this.uploadedFile == null ? null : this.uploadedFile.Filename;

                    WorkflowInstanceLogService.Create({
                        Entity: {
                            WorkflowInstanceId: this.workflowInstanceId,
                            LogType: 'comment',
                            LogText: text
                        }
                    },
                        response => {
                            this.byId('ChatInput').val('');
                            //this.uploadedFile = null;
                            //this.byId('AttachmentInfo').hide();
                            this.refresh();
                        });
                }
            });

            //Serenity.UploadHelper.addUploadInput({
            //    container: this.byId('AddAttachment'),
            //    zone: null,
            //    inputName: this.idPrefix + "AddAttachment",
            //    allowMultiple: false,
            //    fileDone: (response, name, data) => {
            //        this.uploadedFile = {
            //            OriginalName: name,
            //            Filename: response.TemporaryFile
            //        };
            //
            //        this.byId('AttachmentName').text(Q.coalesce(name, ''));
            //        this.byId('AttachmentInfo').show();
            //    }
            //});

            //this.byId('RemoveAttachment').click(() => {
            //    this.uploadedFile = null;
            //    this.byId('AttachmentName').text('');
            //    this.byId('AttachmentInfo').hide();
            //});

            //Chat.attachUserMentions(this.byId('ChatInput'));

            this.byId('SearchInput').keypress(e => {
                if (e.which == 13) {
                    var text = (this.byId('SearchInput').val() || "").trim();
                    if (!text.length) {
                        Q.notifyWarning('Please enter some text for searching!');
                        return;
                    }

                }
            });
        }

        get workflowInstanceId(): number {
            return this._workflowInstanceId;
        }

        set workflowInstanceId(value: number) {
            if (this._workflowInstanceId != value) {
                this._workflowInstanceId = value;
                this.refresh();
            }
        }
        
        //public static attachUserMentions(target: JQuery) {
        //    if (window['Tribute']) {
        //        var tribute = new window['Tribute']({
        //            values: Administration.UserRow.getLookup().items.map(x => ({
        //                key: x.DisplayName + ' (' + x.Username + ')',
        //                value: x.Username
        //            }))
        //        });
        //        tribute.attach(target[0]);
        //    }
        //}

        protected filterItem(item: WorkflowInstanceLogRow): boolean {
            return true;
        }

        protected refresh() {

            if (!this.workflowInstanceId) {
                this.items = [];
                this.renderItems();
                return;
            }

            WorkflowInstanceLogService.List({
                EqualityFilter: {
                    WorkflowInstanceId: this.workflowInstanceId ?? -1
                },
                ContainsText: this.searchTerm,
            },
                response => {
                    this.items = response.Entities || [];
                    this.renderItems();
                    this.scrollToBottom();
                });

            this.byId('CommentsList').show();
            this.byId('ChatBox').show();
        }

        protected renderItems() {
            var noteList = this.byId('CommentsList');
            noteList.children().remove();
            if (!this.items)
                return;

            var index = 0;
            for (var t1 = 0; t1 < this.items.length; t1++) {
                var item = this.items[t1];

                if (!this.filterItem(item))
                    continue;

                var id = 0;
                var text = item.LogText;

                var li = $('<li/>').data('index', index);
                $('<div/>').addClass('note-text').text(text).appendTo(li);

                //if (item.AttachmentPath && Serenity.UploadHelper.hasImageExtension(item.AttachmentPath)) {
                    //var a = CommentsEditor.renderImage(item.AttachmentPath)
                        //.appendTo(li);
                    //Serenity.UploadHelper.colorBox(a, new Object());
                //}
                //else if (item.AttachmentPath && CommentsEditor.hasVideoExtension(item.AttachmentPath)) {
                    //CommentsEditor.renderVideo(item.AttachmentPath).appendTo(li);
                //}

                var editLink = $('<a/>').attr('href', 'javascript:;').addClass('note-date')
                    .text(item.CreatedBy + ' - ' +
                        Q.formatDate(item.CreatedWhen, 'g'))
                    .appendTo(li);

                li.appendTo(noteList);
                index++;
            }
            noteList.children().last().addClass('active');
        }

        protected scrollToBottom() {
            this.byId("CommentsList").scrollTop(this.byId("CommentsList")[0].scrollHeight);
        }

        set_readOnly(value: boolean) {
            this.byId('SearchInput').attr('readonly', value ? 'readonly' : null);
        }

        get_readOnly() {
            return !!this.byId('SearchInput').attr('readonly');
        }

        public getTemplate() {
            return (
`<div>
    <input id="~_SearchInput" type="text" class="s-QuickSearchInput pull-right" />
</div>
<div id="~_CommentsList" class="comments-list">

</div>
 
<div id="~_ChatBox" class="chat-box">
    <input id="~_ChatInput" type="text" class="chat-input" placeholder="Type a message" />
    <!--<div class="attachment-section pull-right">
        <span id="~_AttachmentInfo" style="display: none">
            <i class="fa fa-paperclip"></i> <span id="~_AttachmentName"></span>
            <a id="~_RemoveAttachment" href="javascript:;" title="remove" style="margin-right: 4px"><i class="fa fa-times text-red"></i></a>
        </span>
        <button id="~_AddAttachment" class="btn btn-default btn-sm"><i class="fa fa-paperclip"></i> Select File</button>
        <div class="clear"></div>
    </div>-->
</div>`);
        }
    }
}